import { render, staticRenderFns } from "./ed-auth-popup.vue?vue&type=template&id=08e8d5cc&"
import script from "./ed-auth-popup.ts?vue&type=script&lang=ts&"
export * from "./ed-auth-popup.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports